import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { inboxFolderService } from '../services/inbox-folder.service';
import { queryKeys } from './query-keys';
import type {
  CreateInboxFolderPayload,
  UpdateInboxFolderPayload,
} from '../entities/inbox-folder.entity';

export function useInboxFolders() {
  return useQuery({
    queryKey: queryKeys.inboxFolders.all(),
    queryFn: () => inboxFolderService.loadAll(),
  });
}

export function useCreateInboxFolder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateInboxFolderPayload) => inboxFolderService.create(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.inboxFolders.all() });
    },
  });
}

export function useUpdateInboxFolder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: UpdateInboxFolderPayload }) =>
      inboxFolderService.update(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.inboxFolders.all() });
    },
  });
}

export function useDeleteInboxFolder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => inboxFolderService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.inboxFolders.all() });
    },
  });
}
